import axios from "axios";
import moment from "moment";
import html2canvas from "html2canvas";
import printJs from "print-js";
import jsPDF from "jspdf";
import { toast } from "react-toastify";

const BASE_URL = "https://ontriv.spinxe.com";
// const token = localStorage.getItem("ontrivUserToken");
export const Axios = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const setAuthToken = (token) => {
  if (token) {
    // axios.defaults.headers.common['X-CSRFToken'] = token;
    // axios.defaults.headers.common['Authorization'] = token;
    Axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
    Axios.defaults.headers.common = { Authorization: `bearer ${token}` };
  } else {
    // delete axios.defaults.headers.common['X-CSRFToken'];
    delete Axios.defaults.headers.common["Authorization"];
  }
};

export const setCurrentUser = (data) => {
  try {
    if (data) {
      localStorage.setItem("ontrivUserToken", data.access_token);
      localStorage.setItem(
        "ontrivCurrentUser",
        JSON.stringify(Object.assign(data.user, data.profile))
      );
    } else {
      localStorage.removeItem("ontrivUserToken");
      localStorage.removeItem("ontrivCurrentUser");
    }
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setCurrentUser -> error", error);
  }
};
export const role = (userType) => {
  if (userType?.toLowerCase() === "business owner") {
    return "business";
  } else if (userType?.toLowerCase() === "client manager") {
    return "client-manager";
  } else if (userType?.toLowerCase() === "content manager") {
    return "content-manager";
  }
};
export const setUserType = (role) => {
  localStorage.setItem("user_type", role);
};
export const getUserType = () => {
  return localStorage.getItem("user_type");
};
export const getAuthToken = () => {
  return localStorage.getItem("ontrivUserToken");
};

export const calculateTotal = (items) => {
  let itemAmountsArray = [];
  let total = 0;
  if (items?.length) {
    itemAmountsArray = items?.map((item) => parseInt(item?.amount));
    total = itemAmountsArray?.reduce((a, b) => a + b);
  }

  return total;
};

export const formatInvoiceIssueDate = (date) => {
  return moment(date).format("MM/DD/YYYY");
};

export const stringDateFormat = (date) => {
  return moment(date).format("DD MMMM, YYYY");
};

export const formatNumber = (num) => {
  if (!num) {
    return;
  }
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatAmount = (num) => {
  if (num) {
    const initial = parseFloat(num).toFixed(2);
    return initial.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

export const paymentStatus = (status) => {
  if (status === "Pending") {
    return (
      <div className="list-client-tag-pending text-center d-flex align-items-center justify-content-center">
        <div
          className="status-tag-circle"
          style={{ backgroundColor: "#ED8000" }}
        ></div>
        <span>{status}</span>
      </div>
    );
  } else if (status === "Paid") {
    return (
      <div className="list-client-tag-paid text-center d-flex align-items-center justify-content-center">
        <div
          className="status-tag-circle"
          style={{ backgroundColor: "#57D9A3" }}
        ></div>
        <span>{status}</span>
      </div>
    );
  } else {
    return (
      <div className="list-client-tag-overdue text-center d-flex align-items-center justify-content-center">
        <div
          className="status-tag-circle"
          style={{ backgroundColor: "#FF2154" }}
        ></div>
        <span>{status}</span>
      </div>
    );
  }
};

export const invoicePaymentStatus = (status) => {
  if (status === "Pending") {
    return (
      <>
        <span className="d-flex justify-content-end status">Status</span>
        <div className="d-flex w-100 justify-content-end">
          {/* <MdPending className="ms-auto" color="#ffc107" size="24px" /> */}
          <h6 className="invoice-modal__status invoice-modal__pending mt-2 pl-2">
            {status}
          </h6>
        </div>
      </>
    );
  } else if (status === "Paid") {
    return (
      <>
        <span className="d-flex justify-content-end status">Status</span>
        <div className="d-flex w-100 justify-content-end">
          <h6 className="invoice-modal__status invoice-modal__paid mt-2 pl-2">
            {status}
          </h6>
        </div>
      </>
    );
  } else {
    return (
      <>
        <span className="d-flex justify-content-end status">Status</span>
        <div className="d-flex w-100 justify-content-end">
          <h6 className="invoice-modal__status invoice-modal__overdue mt-2 pl-2">
            {status}
          </h6>
        </div>
      </>
    );
  }
};

export const pdfWithPrintJs = (printable, documentTitle, type = "image") => {
  // const cssText = `
  //   background-color: #ffffff
  // `;
  try {
    html2canvas(document.getElementById(printable), {
      logging: true,
      allowTaint: true,
      letterRendering: 1,
      useCORS: true,
      backgroundColor: "white",
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const config = {
        type,
        documentTitle,
        printable: imgData,
        base64: true,
        // targetStyle: [cssText],
        // maxWidth: 800,
      };
      printJs(config);
    });
  } catch (e) {
    console.log(
      "Failed!",
      "PDF generation failed.\n Page might be too large.\n",
      "error"
    );
  }
};

export const downloadPdf = (printable) => {
  const input = document.getElementById(printable);
  html2canvas(input, { logging: true, letterRendering: 1, useCORS: true }).then(
    (canvas) => {
      const imgWidth = 208;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const imgData = canvas.toDataURL("img/png");
      const pdf = new jsPDF("p", "mm", "a4");
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save("invoice.pdf");
    }
  );
};

export const copierHelper = (text, message) => {
  if (text) {
    navigator.clipboard.writeText(text);

    toast.success(`${message} copied`);
  } else {
    toast.error("Failed to copy to clipboard, try again later");
  }
};

export const calculateVat = (total, vat) => {
  return (vat / 100) * total;
};

export const truncateText = (string = "", length = "30", ending = "...") => {
  if (!(string && length)) {
    return;
  }
  return length > string.length
    ? string
    : string.substring(0, length - ending.length) + ending;
};

export const GenerateString = (length) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const capitalizeFirstLetter = (word) => {
  const firstLetter = word.charAt(0);
  const firstLetterCap = firstLetter.toUpperCase();
  const remainingLetters = word.slice(1);
  const capitalizedWord = firstLetterCap + remainingLetters;

  return capitalizedWord;
};

export const getClientModalDetails = (type) => {
  switch (type) {
    case "website":
      return {
        header: "Website",
        subHeader: "Add the Client’s website URL",
        fieldName: "client_business_website",
        fieldPlaceholder: "https://www.website.com",
        fieldType: "text",
      };
    case "hashtag":
      return {
        header: "Hashtag sets",
        subHeader:
          "Add three or more hashtag sets for use on social media posts",
        fieldName: "client_business_website",
        fieldType: "textarea",
      };
    case "brandcolor":
      return {
        header: "Brand Color",
        subHeader: "Add the Client’s brand colors and HEX",
        fieldName: "brand_color",
        fieldType: "textarea",
      };
    case "brandfont":
      return {
        header: "Brand Fonts",
        subHeader: "Add the names of the different fonts the Client uses",
        fieldName: "brand_font",
        fieldType: "textarea",
      };
    case "preferredtone":
      return {
        header: "Brand voice",
        subHeader: "Add your Client’s preferred brand tone and writing style",
        fieldName: "preferred_tone",
        fieldType: "textarea",
      };
    case "targetaudience":
      return {
        header: "Target audience",
        subHeader:
          "Add information about the specific consumers your client plans to serve",
        fieldName: "target_audience",
        fieldType: "textarea",
      };
    case "maingoal":
      return {
        header: "Goals",
        subHeader: "What your client aim’s to achieve with your service",
        fieldName: "main_goal",
        fieldType: "textarea",
      };
    case "usp":
      return {
        header: "Unique Value",
        subHeader: "What differentiates your client from competitors",
        fieldName: "USP",
        fieldType: "textarea",
      };
    case "notes":
      return {
        header: "About",
        subHeader: "General information about the client",
        fieldName: "notes",
        fieldType: "textarea",
      };
    default:
      return {
        header: "Nothing",
      };
  }
};

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
